export enum ConsultationStatus {
  Upcoming = 'Upcoming',
  Completed = 'Completed',
  Ongoing = 'Ongoing',
  Awaiting = 'Awaiting Patient',
  Cancelled_Patient = 'Canceled by Patient',
  Cancelled_Pharmacy = 'Canceled by Prescriber',
}
